import type {
  ConfirmSignUpInput,
  ResendSignUpHandler,
  SignUpInput,
} from "hooks/authProvider/authProvider";
import type { SignUpStatus } from "hooks/authProvider/useSignUpStatus";
import type { SubmitHandler } from "react-hook-form";
import { SignUpConfirmUI } from "routes/SignUpPage/components/SignUpConfirm";
import { SignUpInputUI } from "routes/SignUpPage/components/SignUpInput";

type SignUpPageProps = {
  signUpInput: SignUpInput;
  signUpStatus: SignUpStatus;
  onSignUp: SubmitHandler<SignUpInput>;
  onConfirmSignUp: SubmitHandler<Omit<ConfirmSignUpInput, "email">>;
  onResendSignUp: ResendSignUpHandler;
  isConfirming?: boolean;
  defaultEmail?: string;
};

export const SignUpPage = ({
  signUpStatus,
  onSignUp,
  onConfirmSignUp,
  onResendSignUp,
  isConfirming = false,
  defaultEmail,
}: SignUpPageProps) => {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-4 py-8">
      {/* Logo Section */}
      <div className="mb-4">
        <img
          className="w-full max-w-md h-auto drop-shadow-lg -translate-x-4"
          src={`${process.env.PUBLIC_URL}/images/strix_search_top_logo1.png`}
          alt="Strix Search"
        />
      </div>

      {/* Form Section */}
      <div className="w-full max-w-md">
        {signUpStatus.confirming ? (
          <SignUpConfirmUI
            onConfirmSignUp={onConfirmSignUp}
            onResendSignUp={onResendSignUp}
            isLoading={isConfirming}
          />
        ) : (
          <SignUpInputUI onSignUp={onSignUp} defaultEmail={defaultEmail} />
        )}
      </div>
    </div>
  );
};
